import React, { Fragment,useEffect,useState } from "react";
import { Link,useLocation } from "react-router-dom";

export default function Sidebar() {
  const [activeMenu, setActiveItem] = useState("/");
  const [list, setList] = useState(false)
  const location = useLocation();
  useEffect(() => {
  const currentActive = window.location.pathname || "/";
  setActiveItem(currentActive);

  }, [location]);
  const dropDownLink = () => {
    setList(!list)
  }

  return (
    <Fragment>
      <div className="admin-sidebar sidebar-hide">
        <ul>
        <li className={activeMenu === "/admin/dashboard" ? "active" : ""} >
            <Link
              to={{
                pathname: "/admin/dashboard",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24.605"
                height="21.933"
                viewBox="0 0 24.605 21.933"
              >
                <g id="home_1_" data-name="home (1)" transform="translate(0 0)">
                  <g id="Group_4" data-name="Group 4">
                    <g id="Group_3" data-name="Group 3">
                      <path
                        id="Path_1"
                        data-name="Path 1"
                        d="M24.343,36.461,12.68,27.921a.639.639,0,0,0-.755,0L.261,36.461a.639.639,0,1,0,.755,1.032L12.3,29.229l11.285,8.263a.639.639,0,0,0,.755-1.032Z"
                        transform="translate(0.001 -27.797)"
                        fill=""
                      />
                    </g>
                  </g>
                  <g
                    id="Group_6"
                    data-name="Group 6"
                    transform="translate(2.713 9.839)"
                  >
                    <g
                      id="Group_5"
                      data-name="Group 5"
                      transform="translate(0 0)"
                    >
                      <path
                        id="Path_2"
                        data-name="Path 2"
                        d="M74.992,232.543a.639.639,0,0,0-.639.639v10.176H69.238V237.8a3.2,3.2,0,1,0-6.393,0v5.555H57.731V233.182a.639.639,0,1,0-1.279,0V244a.639.639,0,0,0,.639.639h6.393a.639.639,0,0,0,.637-.589.482.482,0,0,0,0-.05V237.8a1.918,1.918,0,1,1,3.836,0V244a.465.465,0,0,0,0,.049.639.639,0,0,0,.637.59h6.393a.639.639,0,0,0,.639-.639V233.182A.639.639,0,0,0,74.992,232.543Z"
                        transform="translate(-56.452 -232.543)"
                        fill=""
                      />
                    </g>
                  </g>
                </g>
              </svg>
              Dashboard
            </Link>
          </li>
          <li className={["/admin/agency-create","/admin/agency"].includes(activeMenu) ? "active" : ""} >
            <Link
              to={{
                pathname: "/admin/agency",
              }}
            >
              <svg
                id="user_1_"
                data-name="user (1)"
                xmlns="http://www.w3.org/2000/svg"
                width="30.889"
                height="20.145"
                viewBox="0 0 30.889 20.145"
              >
                <g
                  id="Group_11"
                  data-name="Group 11"
                  transform="translate(10.744)"
                >
                  <g id="Group_10" data-name="Group 10">
                    <path
                      id="Path_3"
                      data-name="Path 3"
                      d="M175.366,85.333a4.7,4.7,0,1,0,4.7,4.7A4.706,4.706,0,0,0,175.366,85.333Zm0,8.058a3.357,3.357,0,1,1,3.357-3.357A3.362,3.362,0,0,1,175.366,93.391Z"
                      transform="translate(-170.666 -85.333)"
                      fill=""
                    />
                  </g>
                </g>
                <g
                  id="Group_13"
                  data-name="Group 13"
                  transform="translate(21.488 5.372)"
                >
                  <g
                    id="Group_12"
                    data-name="Group 12"
                    transform="translate(0 0)"
                  >
                    <path
                      id="Path_4"
                      data-name="Path 4"
                      d="M344.691,170.667a3.357,3.357,0,1,0,3.357,3.357A3.362,3.362,0,0,0,344.691,170.667Zm0,5.372a2.014,2.014,0,1,1,2.014-2.014A2.017,2.017,0,0,1,344.691,176.039Z"
                      transform="translate(-341.334 -170.667)"
                      fill=""
                    />
                  </g>
                </g>
                <g
                  id="Group_15"
                  data-name="Group 15"
                  transform="translate(2.781 5.372)"
                >
                  <g
                    id="Group_14"
                    data-name="Group 14"
                    transform="translate(0 0)"
                  >
                    <path
                      id="Path_5"
                      data-name="Path 5"
                      d="M47.539,170.667a3.357,3.357,0,1,0,3.357,3.357A3.361,3.361,0,0,0,47.539,170.667Zm0,5.372a2.014,2.014,0,1,1,2.014-2.014A2.017,2.017,0,0,1,47.539,176.039Z"
                      transform="translate(-44.182 -170.667)"
                      fill=""
                    />
                  </g>
                </g>
                <g
                  id="Group_17"
                  data-name="Group 17"
                  transform="translate(6.715 10.744)"
                >
                  <g id="Group_16" data-name="Group 16">
                    <path
                      id="Path_6"
                      data-name="Path 6"
                      d="M115.4,256a8.739,8.739,0,0,0-8.729,8.729.672.672,0,0,0,1.343,0,7.386,7.386,0,1,1,14.773,0,.672.672,0,0,0,1.343,0A8.739,8.739,0,0,0,115.4,256Z"
                      transform="translate(-106.666 -256)"
                      fill=""
                    />
                  </g>
                </g>
                <g
                  id="Group_19"
                  data-name="Group 19"
                  transform="translate(21.392 13.43)"
                >
                  <g id="Group_18" data-name="Group 18">
                    <path
                      id="Path_7"
                      data-name="Path 7"
                      d="M343.266,298.667a6.043,6.043,0,0,0-3.13.873.672.672,0,0,0,.7,1.148,4.7,4.7,0,0,1,7.134,4.022.672.672,0,0,0,1.343,0A6.051,6.051,0,0,0,343.266,298.667Z"
                      transform="translate(-339.813 -298.667)"
                      fill=""
                    />
                  </g>
                </g>
                <g
                  id="Group_21"
                  data-name="Group 21"
                  transform="translate(0 13.43)"
                >
                  <g id="Group_20" data-name="Group 20">
                    <path
                      id="Path_8"
                      data-name="Path 8"
                      d="M9.173,299.539A6.045,6.045,0,0,0,0,304.71a.672.672,0,0,0,1.343,0,4.7,4.7,0,0,1,7.133-4.024.672.672,0,0,0,.7-1.148Z"
                      transform="translate(0 -298.667)"
                      fill=""
                    />
                  </g>
                </g>
              </svg>
              Agency
            </Link>
          </li>
           
          <li className={activeMenu === "/admin/templates" ? "active" : ""} >
            {" "}
            <Link
              to={{
                pathname: "/admin/templates",
              }}
            >
      <svg   width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zm-22.6 22.7c2.1 2.1 3.5 4.6 4.2 7.4H256V32.5c2.8.7 5.3 2.1 7.4 4.2l83.9 83.9zM336 480H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h176v104c0 13.3 10.7 24 24 24h104v304c0 8.8-7.2 16-16 16z"/></svg>
              Templates
            </Link>
          </li>

          <li className={activeMenu === "/admin/employee" ? "active" : ""} >
            {" "}
            <Link
              to={{
                pathname: "/admin/employee",
              }}
            >
              <svg
                id="suitcase"
                xmlns="http://www.w3.org/2000/svg"
                width="22.784"
                height="17.45"
                viewBox="0 0 22.784 17.45"
              >
                <g id="Group_23" data-name="Group 23">
                  <path
                    id="Path_9"
                    data-name="Path 9"
                    d="M20.782,62.767H14.537v-.829a2,2,0,0,0-2-2H10.25a2,2,0,0,0-2,2v.829H2a2,2,0,0,0-2,2V75.382a2,2,0,0,0,2,2H20.782a2,2,0,0,0,2-2V64.769A2,2,0,0,0,20.782,62.767ZM10.25,61.27h2.284a.668.668,0,0,1,.668.668v.829H9.582v-.829h0A.668.668,0,0,1,10.25,61.27ZM3.915,76.05H2a.668.668,0,0,1-.668-.668V64.769A.668.668,0,0,1,2,64.1H3.915V76.05Zm13.619,0H5.25V64.1H17.534Zm3.915-.668a.668.668,0,0,1-.668.668H18.869V64.1h1.913a.668.668,0,0,1,.668.668Z"
                    transform="translate(0 -59.935)"
                    fill=""
                  />
                </g>
              </svg>
              Employee
            </Link>
          </li>
          <li className={activeMenu === "/admin/settings" ? "active" : ""} >
            {" "}
            <Link
              to={{
                pathname: "/admin/settings",
              }}
            >
              <svg
                id="setting-lines"
                xmlns="http://www.w3.org/2000/svg"
                width="17.122"
                height="16.784"
                viewBox="0 0 17.122 16.784"
              >
                <path
                  id="Path_10"
                  data-name="Path 10"
                  d="M3.659,53.594H.5a.5.5,0,1,1,0-1.007H3.659a.5.5,0,1,1,0,1.007Z"
                  transform="translate(0 -50.784)"
                  fill=""
                />
                <path
                  id="Path_11"
                  data-name="Path 11"
                  d="M86.443,9.116A2.307,2.307,0,1,1,88.749,6.81,2.309,2.309,0,0,1,86.443,9.116Zm0-3.606a1.3,1.3,0,1,0,1.3,1.3A1.3,1.3,0,0,0,86.443,5.51Z"
                  transform="translate(-80.981 -4.503)"
                  fill=""
                />
                <path
                  id="Path_12"
                  data-name="Path 12"
                  d="M237.035,53.594h-7.527a.5.5,0,1,1,0-1.007h7.527a.5.5,0,0,1,0,1.007Z"
                  transform="translate(-220.417 -50.784)"
                  fill=""
                />
                <path
                  id="Path_13"
                  data-name="Path 13"
                  d="M266.736,171.387a2.307,2.307,0,1,1,2.307-2.307A2.309,2.309,0,0,1,266.736,171.387Zm0-3.606a1.3,1.3,0,1,0,1.3,1.3A1.3,1.3,0,0,0,266.736,167.781Z"
                  transform="translate(-254.512 -160.688)"
                  fill=""
                />
                <path
                  id="Path_14"
                  data-name="Path 14"
                  d="M8.594,215.857H.5a.5.5,0,0,1,0-1.007h8.09a.5.5,0,0,1,0,1.007Z"
                  transform="translate(0 -206.961)"
                  fill=""
                />
                <path
                  id="Path_15"
                  data-name="Path 15"
                  d="M363.682,215.857h-2.592a.5.5,0,1,1,0-1.007h2.592a.5.5,0,1,1,0,1.007Z"
                  transform="translate(-347.064 -206.961)"
                  fill=""
                />
                <path
                  id="Path_16"
                  data-name="Path 16"
                  d="M71.42,333.65a2.307,2.307,0,1,1,2.307-2.307A2.309,2.309,0,0,1,71.42,333.65Zm0-3.606a1.3,1.3,0,1,0,1.3,1.3A1.3,1.3,0,0,0,71.42,330.044Z"
                  transform="translate(-66.521 -316.866)"
                  fill=""
                />
                <path
                  id="Path_17"
                  data-name="Path 17"
                  d="M222.573,378.121h-8.09a.5.5,0,0,1,0-1.007h8.09a.5.5,0,0,1,0,1.007Z"
                  transform="translate(-205.954 -363.14)"
                  fill=""
                />
                <path
                  id="Path_18"
                  data-name="Path 18"
                  d="M3.1,378.12H.5a.5.5,0,0,1,0-1.007H3.1a.5.5,0,0,1,0,1.007Z"
                  transform="translate(0 -363.139)"
                  fill=""
                />
              </svg>
              Settings
            </Link>
          </li>
          <li className={["/admin/agencyreport","/admin/paymentreport"].includes(activeMenu)  ? "active" : ""} onClick={dropDownLink}>
            {" "}
            <Link
              to="#"
            >
              <svg
                id="bar-chart"
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="17"
                viewBox="0 0 17 17"
              >
                <g id="Group_74" data-name="Group 74">
                  <g id="Group_73" data-name="Group 73">
                    <rect
                      id="Rectangle_1107"
                      data-name="Rectangle 1107"
                      width="17"
                      height="1"
                      transform="translate(0 16)"
                      fill=""
                    />
                    <path
                      id="Path_71"
                      data-name="Path 71"
                      d="M24.281,293.624h2.812a.281.281,0,0,0,.281-.281v-5.061a.281.281,0,0,0-.281-.281H24.281a.281.281,0,0,0-.281.281v5.061A.281.281,0,0,0,24.281,293.624Zm.281-5.061h2.249v4.5H24.562Z"
                      transform="translate(-23.156 -277.877)"
                      fill=""
                    />
                    <path
                      id="Path_72"
                      data-name="Path 72"
                      d="M248.281,201h2.812a.281.281,0,0,0,.281-.281v-8.436a.281.281,0,0,0-.281-.281h-2.812a.281.281,0,0,0-.281.281v8.436A.281.281,0,0,0,248.281,201Zm.281-8.435h2.249v7.873h-2.249Z"
                      transform="translate(-239.283 -185.252)"
                      fill=""
                    />
                    <path
                      id="Path_73"
                      data-name="Path 73"
                      d="M136.281,108.372h2.812a.281.281,0,0,0,.281-.281V96.281a.281.281,0,0,0-.281-.281h-2.812a.281.281,0,0,0-.281.281v11.81A.281.281,0,0,0,136.281,108.372Zm.281-11.81h2.249V107.81h-2.249Z"
                      transform="translate(-131.22 -92.626)"
                      fill=""
                    />
                    <path
                      id="Path_74"
                      data-name="Path 74"
                      d="M360.281,15.746h2.812a.281.281,0,0,0,.281-.281V.281A.281.281,0,0,0,363.093,0h-2.812A.281.281,0,0,0,360,.281V15.465A.281.281,0,0,0,360.281,15.746ZM360.562.562h2.249V15.184h-2.249Z"
                      transform="translate(-347.347)"
                      fill=""
                    />
                  </g>
                </g>
              </svg>
              Report
            </Link>
          </li>
        {list ? 
        <>
        <li className= {["/admin/agencyreport"].includes( activeMenu) ? "submenu active" : "submenu"} >
            {" "}
            <Link
              to={{
                pathname: "/admin/agencyreport",
              }}
            >
<svg width="10" height="10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512"><path d="M248 40c119.3 0 216 96.6 216 216 0 119.3-96.6 216-216 216-119.3 0-216-96.6-216-216 0-119.3 96.6-216 216-216m0-32C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 216c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32 14.4-32 32-32m0-32c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64z"/></svg>

             Agency
            </Link>
          </li>

          <li className={["/admin/paymentreport"].includes( activeMenu) ? "submenu active" : "submenu"} >
            {" "}
            <Link
              to={{
                pathname: "/admin/paymentreport",
              }}
            >
<svg width="10" height="10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512"><path d="M248 40c119.3 0 216 96.6 216 216 0 119.3-96.6 216-216 216-119.3 0-216-96.6-216-216 0-119.3 96.6-216 216-216m0-32C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 216c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32 14.4-32 32-32m0-32c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64z"/></svg>
              Payments
            </Link>
          </li>
          </>
          : "" }

        </ul>
      </div>
    </Fragment>
  );
}
